import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthCheckRoutingModule } from './auth.check.routing';
import { AuthCheckComponent }   from './auth.check.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AuthCheckRoutingModule,
  ],
  exports: [],
  declarations: [
    AuthCheckComponent,
  ],
  providers: [],
})
export class AuthCheckModule {
}
